import { useNavigate, useLocation } from "react-router-dom";
import { LogOut, LayoutGrid, CreditCard, Shield } from "lucide-react";
import { Logo } from "./Logo";
import { useAuth } from "../context/AuthContext";

export function TopBar() {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, logout } = useAuth();

  const doLogout = async () => { await logout(); navigate("/"); };
  const link = (path, label, Icon) => (
    <button data-testid={`nav-${label.toLowerCase()}`} onClick={() => navigate(path)}
      className={`flex items-center gap-2 px-3 py-1.5 rounded-lg text-sm transition-colors ${location.pathname === path ? "bg-white/[0.06] text-white" : "text-slate-400 hover:text-white"}`}>
      <Icon className="h-4 w-4" /> {label}
    </button>
  );

  return (
    <header className="sticky top-0 z-40 glass border-b border-white/10">
      <div className="max-w-[1600px] mx-auto px-6 h-14 flex items-center justify-between">
        <div className="flex items-center gap-6">
          <Logo size="sm" to="/dashboard" />
          <nav className="hidden md:flex items-center gap-1">
            {link("/dashboard", "Projects", LayoutGrid)}
            {link("/billing", "Billing", CreditCard)}
            {link("/admin", "Admin", Shield)}
          </nav>
        </div>
        <div className="flex items-center gap-3">
          <span className="hidden sm:inline text-xs font-mono px-2.5 py-1 rounded-full bg-indigo-500/10 text-indigo-300 capitalize">{user?.plan || "free"}</span>
          <div className="flex items-center gap-2">
            {user?.picture
              ? <img src={user.picture} alt="" className="h-7 w-7 rounded-full object-cover" />
              : <div className="h-7 w-7 rounded-full bg-indigo-600 flex items-center justify-center text-xs font-semibold">{(user?.name || user?.email || "U")[0].toUpperCase()}</div>}
            <span className="hidden sm:inline text-sm text-slate-300 max-w-[120px] truncate">{user?.name || user?.email}</span>
          </div>
          <button data-testid="logout-button" onClick={doLogout} className="p-2 rounded-lg text-slate-400 hover:text-white hover:bg-white/[0.06] transition-colors">
            <LogOut className="h-4 w-4" />
          </button>
        </div>
      </div>
    </header>
  );
}
